export default __webpack_public_path__ + "ee663564f43e26133fe78a07c8f41782.png";